module.exports = __webpack_public_path__ + "images/_/programs/h2whoaHybrid/images/characters/sara_twist_hands_out_yay-bcf1fb30eda8e0aa404ef594e2dd3fd6.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoaHybrid/images/characters/sara_twist_hands_out_yay.png
// module id = 2414
// module chunks = 2